// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"fd101cce","316":"aabc6c34","453":"300d0172","615":"0d04d312","661":"ba5849a1","750":"73452beb"}[chunkId] + ".chunk.js";
};